import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "./GallerySlider.scss";
import { A11y, Navigation, Scrollbar } from "swiper/modules";
import { useEffect, useRef } from "react";
import GalleryVerticalSlider from "../GalleryVerticalSlider/GalleryVerticalSlider";
import { GalleryI, PhotoI } from "@/interfaces/galleries/Galleries";
import { useGalleryContext } from "@/context/GalleryContext";

interface GallerySliderPropsI {
  gallery: GalleryI;
  years: string[];
  photos: { [key: string]: PhotoI[] };
}

function GallerySlider(props: GallerySliderPropsI) {
  const { years, photos, gallery } = props;
  const {
    activeXIndex: iX,
    setActiveXIndex: changeIx,
    setActiveYIndex: changeIy,
    activeYIndex: iY,
  } = useGalleryContext();
  const swiperRef = useRef<any>(null);
  const navigationPrevRef = useRef<any>(null);
  const navigationNextRef = useRef<any>(null);

  const onSlideChange = (e: any) => {
    changeIx(e.activeIndex);
  };

  const nextSlide = () => {
    const nextIndex = iX + 1;
    if (nextIndex <= swiperRef.current.slides.length - 1) {
      changeIx(nextIndex);
      swiperRef.current.slideTo(nextIndex);
    }
  };

  const prevSlide = () => {
    const nextIndex = iX - 1;
    console.log("Prev button clicked. Swiper ref:", swiperRef.current);
    if (nextIndex >= 0) {
      changeIx(nextIndex);
      if (nextIndex < iX) {
        swiperRef.current.slideTo(nextIndex);
      }
    } else {
      console.log("Swiper ref is null or undefined!");
    }
  };

  useEffect(() => {
    if (!swiperRef.current) return;
    try {
      swiperRef.current.update?.();
      swiperRef.current.slideTo?.(iX);
      if (swiperRef.current.navigation) {
        swiperRef.current.navigation.destroy();
        swiperRef.current.navigation.init();
        swiperRef.current.navigation.update();
      }
      if (swiperRef.current.scrollbar) {
        swiperRef.current.scrollbar.updateSize?.();
      }
    } catch (_) {
      // ignore
    }
  }, [iX, years.length]);

  return (
    <div className={`gallery-slider-main-container `}>
      <Swiper
        modules={[Navigation, A11y, Scrollbar]}
        spaceBetween={10}
        centeredSlides={true}
        slidesPerView={1.5}
        breakpoints={{
          500: {
            slidesPerView: 2,
          },
          750: {
            slidesPerView: 3,
          },
          900: {
            slidesPerView: 4,
          },
          1100: {
            slidesPerView: 5,
            centeredSlides: false,
          },
          1300: {
            slidesPerView: 6,
            centeredSlides: false,
          },
        }}
        scrollbar={{ draggable: true, hide: false }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(e) => onSlideChange(e)}
      >
        {years.map((year, i) => {
          return (
            <SwiperSlide
              key={"gallery-horizontal-slide-" + year}
              className={i === iX ? "active-slide" : ""}
            >
              <GalleryVerticalSlider
                photos={photos}
                year={+year}
                iX={iX}
                iY={iY}
                changeIy={changeIy}
                index={i}
                gallery={gallery}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div
        className="custom-swiper-button-prev"
        ref={navigationPrevRef}
        role="button"
        onClick={prevSlide}
      ></div>
      <div
        className="custom-swiper-button-next"
        ref={navigationNextRef}
        role="button"
        onClick={nextSlide}
      ></div>
    </div>
  );
}

export default GallerySlider;
